/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { Button, ActiveWrapper, HolidayWrapper, Toolbar } from './templates'
import { handleDateSelect, removeRange, submit, fetchSchedules, handleEvents, handleCheckbox } from './actions'
import Checkbox from 'react-bootstrap/lib/Checkbox'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { Link } from 'react-router-dom'
import { Trans } from 'react-i18next'
import SelectTimeZoneField from '@modules/formFields/SelectTimeZoneField'
import { useTranslation } from 'react-i18next'
import './style.scss'

const Horarios = ({ match: { params } }) => {
  // const [weekendsVisible, setWeekendsVisible] = useState(true);
  const {
    i18n: { language },
    t,
  } = useTranslation()
  const [currentEvents, setCurrentEvents] = useState(null)
  const [activeDays, setActiveDays] = useState(null)
  const [professionalName, setProfessionalName] = useState(null)
  const [onHolidays, setOnHolidays] = useState(null)
  const [timeZone, setTimeZone] = useState(null)
  const [activeButton, setActiveButton] = useState(true)

  const stateParams = {
    currentEvents,
    activeDays,
    onHolidays,
    timeZone,
    params,
  }
  const setParams = {
    setCurrentEvents,
    setActiveDays,
    setProfessionalName,
    setOnHolidays,
    setTimeZone,
    setActiveButton,
    t,
  }

  useEffect(() => {
    fetchSchedules({ ...setParams, params })
  }, [])

  return (
    <div className="horarios">
      <DashboardHeader title={professionalName}>
        <Link className="btn btn-primary" to={`/schedules`}>
          {t('Volver')}
        </Link>
      </DashboardHeader>

      <div className="main-content">
        <Toolbar>
          {onHolidays !== null && (
            <HolidayWrapper>
              <label>
                <Trans>
                  Horario deshabilitado <span>(no fijo o de vacaciones)</span>
                </Trans>
              </label>
              <div>
                <Checkbox checked={onHolidays} onChange={() => setOnHolidays(!onHolidays)} />
              </div>
            </HolidayWrapper>
          )}
          <Button disabled={!activeButton} onClick={() => submit({ ...stateParams, t })}>
            {t('Guardar')}
          </Button>
        </Toolbar>

        {timeZone !== null && (
          <SelectTimeZoneField
            input={{
              value: timeZone,
              onChange: (value) => setTimeZone(value),
            }}
          />
        )}

        {activeDays && (
          <ActiveWrapper>
            <div className="title">{t('Activo')}</div>
            <div className="columns">
              {activeDays.map((selected, index) => {
                return (
                  <div key={`${index}_${selected.day}`}>
                    <Checkbox
                      checked={selected.active}
                      onChange={() => handleCheckbox({ activeDays, setActiveDays, selected })}
                    />
                  </div>
                )
              })}
            </div>
          </ActiveWrapper>
        )}

        {currentEvents && (
          <>
            <FullCalendar
              locale={language}
              eventOverlap={false}
              contentHeight={500}
              plugins={[timeGridPlugin, interactionPlugin]}
              initialView="timeGridWeek"
              // editable={true}
              selectable={true}
              selectMirror={true}
              dayHeaderFormat={{ weekday: 'short' }}
              // disable resize and drag
              editable={false}
              slotLabelFormat={{
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: false,
                meridiem: 'short',
              }}
              // alternatively, use the `events` setting to fetch from a feed
              initialEvents={currentEvents}
              select={(selectedInfo) => handleDateSelect(selectedInfo, currentEvents, t)}
              eventClick={removeRange}
              // called after events are initialized/added/changed/removed
              eventsSet={(events) => handleEvents({ ...setParams, events })}
              slotDuration="00:15:00"
              slotLabelInterval="01:00:00"
              selectOverlap={false}
              allDaySlot={false}
              headerToolbar={false}
              firstDay={1}
              eventColor="#01a8e7"
            />
          </>
        )}
      </div>
    </div>
  )
}
export default Horarios
